const getters = {
  processing: (state) => state.processing,
  bulkProcessing: (state) => state.bulkProcessing,
  lates: (state) => state.lates,
};

export default getters;
